import React from "react"
import { Box, Typography } from "@ridecell/web-components-material"
import { injectIntl } from "react-intl"
import messages from "./messages"

const AddedPaymentMethod = ({ addedCard, intl: { formatMessage } }) => {
  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <Typography variant="body1">
        {formatMessage(messages.paymentMethodAdded)}
      </Typography>
      {addedCard && (
        <Box display="flex" style={{ marginTop: "12px" }}>
          <Typography
            style={{ fontWeight: 600 }}
            variant="body1"
          >{`${addedCard.card_type} `}</Typography>
          <Box style={{ margin: "0 8px" }}>
            <Typography variant="body1">
              {formatMessage(messages.endingIn)}
            </Typography>
          </Box>
          <Typography
            style={{ fontWeight: 600 }}
            variant="body1"
          >{`${addedCard.last_four_digits}`}</Typography>
        </Box>
      )}
    </Box>
  )
}

export default injectIntl(AddedPaymentMethod)
